import * as React from 'react';
import Networking from '../../models/Networking';
import SiteMapType from '../../models/siteMap';
import Communication from '../Communication';
import SiteMap from '../SiteMap';
import Text from '../Text';
import './style.scss';
import classNames from 'classnames';
import { AddressVariants } from '../../models/Address';
import { useTranslation } from 'react-i18next';

interface Props {
  siteMap: SiteMapType[];
  networking: Networking[];
  noFooterCard: boolean;
  isLegacy: boolean;
}

const FooterContent: React.SFC<Props> = ({
  siteMap,
  networking,
  noFooterCard,
  isLegacy,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('footer-content', {
        'footer-content--no-card': noFooterCard,
      })}
    >
      <div className={'footer-content__left-block'}>
        <SiteMap siteMap={siteMap}></SiteMap>
        <Text
          type="caption"
          weight="medium"
          dim="20"
          color="light"
          className={'footer-content__left-block_copyright'}
        >
          {t('footer_copyright', { date: new Date().getFullYear() })}
        </Text>
      </div>
      {isLegacy && (
        <div className={'footer-content__adress'}>
          <Communication
            addresses={[
              {
                title: 'Stormotion Legal Office',
                address: 'Kauptmehe tn. 7-120',
                cityZip: '10114 Tallinn, Estonia',
                variant: AddressVariants.Location,
              },
              {
                title: 'Stormotion Development Office',
                address: 'PE Oleksii Bulavka\nZaporizke Hwy. 48/120',
                cityZip: '49040 Dnipro, Ukraine',
                variant: AddressVariants.Location,
              },
            ]}
            networking={networking}
          />
        </div>
      )}
    </div>
  );
};

export default FooterContent;
